import { API_PATHS } from "../../config/ApiPaths";

export const apiRevenueUnitel = (stateDate, endDate) => {
  return `${API_PATHS.unitel}?startDate=${stateDate}&endDate=${endDate}`;
};
